import { UserType } from "recoil/userAtom";

const TASK_EDITOR_ALLOWED_REAL_COACH_USER_IDS = new Set<number>([
  909, 913, 1321,
]);

type TaskEditorAccessContext = {
  buildTarget: string;
  hostname?: string;
  user?: Pick<UserType, "accessToken" | "role" | "userId">;
};

export function isTaskEditorDevLocalEnvironment(hostname?: string) {
  if (!hostname) {
    return false;
  }

  const normalizedHostname = hostname.toLowerCase();
  return (
    normalizedHostname === "dev.local" ||
    normalizedHostname.endsWith(".dev.local")
  );
}

export function canAccessTaskEditor({
  buildTarget,
  hostname,
  user,
}: TaskEditorAccessContext) {
  if (!user?.accessToken) {
    return false;
  }

  if (isTaskEditorDevLocalEnvironment(hostname)) {
    return true;
  }

  if (buildTarget !== "real") {
    return true;
  }

  if (user?.role !== "coach") {
    return false;
  }

  if (typeof user.userId !== "number") {
    return false;
  }

  return TASK_EDITOR_ALLOWED_REAL_COACH_USER_IDS.has(user.userId);
}
